{
  "accept": "Kabul Et",
  "action": "İşlem",
  "allCountries": "Tüm Ülkeler",
  "allPayments": "Tüm Ödeme Yöntemleri",
  "allTypes": "Tüm Türler",
  "amount": "Miktar",
  "asset": "Varlık",
  "buy": "Al",
  "buyer": "Alıcı",
  "cancel": "İptal",
  "cancelFailed": "Emir iptali başarısız oldu.",
  "cancelled": "İptal Edildi",
  "completed": "Tamamlandı",
  "country": "Ülke",
  "createP2pAd": "P2P İlanı Oluştur",
  "dispute": "İtiraz",
  "disputeReason": "İtiraz Nedeni",
  "escrow": "Emanet",
  "escrowActive": "Emanet Aktif",
  "escrowProtection": "Emanet Koruması",
  "escrowReady": "Emanet Hazır",
  "fillAllFields": "Lütfen tüm zorunlu alanları doldurun.",
  "global": "Küresel",
  "globalP2pTrading": "Küresel P2P Alım Satım",
  "inEscrow": "Emanette",
  "inTrade": "İşlemde",
  "liveGlobalAds": "Canlı Küresel İlanlar",
  "loading": "Yükleniyor...",
  "markPaid": "Ödendi Olarak İşaretle",
  "noP2pAdsFound": "P2P ilanı bulunamadı.",
  "offline": "Çevrimdışı",
  "online": "Çevrimiçi",
  "open": "Açık",
  "openDispute": "İtiraz Aç",
  "orderCancelledRefunded": "Emir iptal edildi ve kilitli varlık iade edildi.",
  "orderDetails": "Emir Detayları",
  "orderId": "Emir ID",
  "p2pOrderCreated": "P2P emri başarıyla oluşturuldu.",
  "p2pSecurity": "P2P Güvenliği",
  "p2pSecurity1": "Kullanıcıdan kullanıcıya işlem",
  "p2pSecurity2": "Canlı veritabanı emirleri",
  "p2pSecurity3": "Emanet durumu takibi",
  "p2pSecurity4": "Ödeme kanıtı yükleme",
  "p2pSecurity5": "Yönetici inceleme desteği",
  "p2pSecurity6": "Güvenli P2P durum akışı",
  "p2pSubtitle": "Güvenli emanet koruması ile dünya çapında kripto alıp satın.",
  "p2pTitle": "Küresel P2P Alım Satım",
  "payment": "Ödeme",
  "paymentMethod": "Ödeme Yöntemi",
  "paymentProof": "Ödeme Kanıtı",
  "paymentSent": "Ödeme Gönderildi",
  "paymentSubmitted": "Ödeme kanıtı başarıyla gönderildi.",
  "pleaseLoginFirst": "Lütfen önce giriş yapın.",
  "price": "Fiyat",
  "processing": "İşleniyor...",
  "release": "Serbest Bırak",
  "releaseFailed": "Varlık serbest bırakma başarısız oldu.",
  "selectPaymentMethod": "Ödeme Yöntemi Seç",
  "sell": "Sat",
  "seller": "Satıcı",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "status": "Durum",
  "totalOrders": "Toplam Emir",
  "tradeCompletedSuccessfully": "İşlem başarıyla tamamlandı.",
  "tradeFailed": "İşlem başarısız oldu.",
  "tradeStartedSuccessfully": "İşlem başarıyla başlatıldı.",
  "trader": "Yatırımcı",
  "unknownTrader": "Tüccar",
  "uploadPaymentProof": "Lütfen ödeme kanıtı yükleyin.",
  "uploadProof": "Kanıt Yükle",
  "verifiedMerchant": "Doğrulanmış Satıcı",
  "waitingEscrow": "Emanet Bekleniyor",
  "walletAddress": "Cüzdan Adresi"
}